module.exports = __webpack_public_path__ + "static/media/vinylot.c3d11841.svg";